/**
 * Escapes the RegExp metacharacters `^ $ . * + ? ( ) [ ] { } |` and the backslash in
 * `string` so upstream data can safely be interpolated into a `new RegExp()` pattern.
 * Lodash-compatible replacement for `_.escapeRegExp`: non-string input is coerced, and
 * `null`/`undefined` become an empty string
 */
const escapeRegExp = (string = '') => {
    const value = string === null ? '' : String(string);

    return value.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
};

export default escapeRegExp;
